import ProjectUtils from "../../../../../../utils/project-utils.js";

export function makeInitialDataItems(data, printOptions = {}) {
    const initialData = data?.attendance?.data ?? {};

    return [
        {
            label: "Protocolo",
            value: initialData?.attendance_protocol ?? "",
        },
        {
            label: "",
            value: " ",
        },
        {
            label: "D/H inicial",
            value: initialData?.attendance_start ?? "",
        },
        {
            label: "D/H final",
            value: initialData?.attendance_end ?? "",
        },
        {
            label: "Natureza",
            value: initialData?.attendance_nature ?? "",
        },
        {
            label: "Prioridade",
            value: initialData?.attendance_priority ?? "",
        },
        {
            label: "Status",
            value: initialData?.attendance_statusname ?? "",
        },
        {
            label: "Canal",
            value: initialData?.attendance_channel ?? "",
        },
    ];
}